/* GRAYISH sanity fixes — 2026-08-15 */
(function(){
  'use strict';

  function fixPromoCards(){
    var handles=[
      '/products/aug26-snow-polymer-free-gift-sale',
      '/products/%D7%97%D7%93%D7%A9-%D7%91-grayish-%D7%90%D7%A8%D7%99%D7%96%D7%95%D7%AA-%D7%9C%D7%99%D7%95%D7%A6%D7%A8%D7%95%D7%AA-%D7%95%D7%9C%D7%A2%D7%A1%D7%A7%D7%99%D7%9D-%D7%A7%D7%98%D7%A0%D7%99%D7%9D-10-%D7%94%D7%A0%D7%97%D7%94-%D7%A2%D7%9C-18-%D7%A7-%D7%92'
    ];
    document.querySelectorAll('.productitem').forEach(function(card){
      var link=Array.from(card.querySelectorAll('a[href]')).find(function(a){
        return handles.indexOf(a.getAttribute('href'))>-1;
      });
      if(!link) return;
      card.querySelectorAll('.productitem--description').forEach(function(description){
        if(description.textContent.trim()==='לפרטי המבצע') description.remove();
      });
      var actions=card.querySelector('.productitem--actions');
      if(!actions) return;
      var target=link.getAttribute('href');
      actions.innerHTML='';
      var details=document.createElement('a');
      details.href=target;
      details.className='productitem--action-trigger grayish-promo-link';
      details.textContent='לפרטי המבצע';
      details.setAttribute('aria-label','לפרטי המבצע');
      actions.appendChild(details);
    });
  }

  function fixCalculatorHeadings(){
    if(location.pathname!='/pages/concretecalc-x') return;
    var headings=Array.from(document.querySelectorAll('h1'));
    if(headings.length<2) return;
    var visible=headings.find(function(h){
      var s=getComputedStyle(h);
      return s.display!=='none'&&s.visibility!=='hidden'&&h.getClientRects().length>0;
    })||headings[headings.length-1];
    headings.forEach(function(h){
      if(h===visible) return;
      var replacement=document.createElement('div');
      replacement.className=h.className;
      replacement.innerHTML=h.innerHTML;
      replacement.setAttribute('aria-hidden','true');
      h.replaceWith(replacement);
    });
  }

  function fixSeparatorsAndAlt(){
    document.querySelectorAll('a').forEach(function(a){
      if(/^_{8,}$/.test(a.textContent.trim())){
        a.removeAttribute('href');
        a.setAttribute('role','separator');
        a.setAttribute('aria-hidden','true');
        a.setAttribute('tabindex','-1');
      }
    });
    document.querySelectorAll('img[src*="Untitled_design_1_50x50.svg"]').forEach(function(img){
      img.alt='';
      img.setAttribute('aria-hidden','true');
    });
  }

  function run(){
    fixPromoCards();
    fixCalculatorHeadings();
    fixSeparatorsAndAlt();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();
})();